import { useEffect, useState } from 'react'

/**
 * useDebounced — trả về giá trị debounced sau `delay` ms.
 * Dùng cho server-side search: gõ liên tục → chỉ trigger 1 API sau khi ngừng.
 */
export function useDebounced<T>(value: T, delay = 300): T {
    const [debounced, setDebounced] = useState(value)
    useEffect(() => {
        const t = setTimeout(() => setDebounced(value), delay)
        return () => clearTimeout(t)
    }, [value, delay])
    return debounced
}
